import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
  onlineAppointment: {
    id: 'LumaBot.MessageAppointments.ListAppointments.onlineAppt',
    defaultMessage: 'Online appointment',
  },
});

export default messages;
